import * as React from "react";
import { Button, Dropdown } from "antd";
import { Menu, Terminal } from "react-feather";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularThemeSwitch } from "../../../CircularThemeSwitch/CircularThemeSwitch";
import { NotificationBellButton } from "../../../NotificationDrawer";
import { GenericCreate } from "../GenericCreate";
import { GlobalSearch } from "../GlobalSearch";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectContext } from "../../../../store/contextSlice";
import { applyActions } from "../../../../store/applySlice";
import "./index.scss";

export const MobileMenu: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  const context = useAppSelector(selectContext);
  const userType = useAppSelector((state) => state.user.type);
  const dashboard = useAppSelector((state) => state.uiData.dashboard);
  const isCreateForm = useAppSelector((state) => state.uiData.isCreateForm);

  const [isOpen, setIsOpen] = React.useState(false);

  // Handle cmd+k / ctrl+k to open mobile menu on small screens
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        // Only handle on mobile (when hamburger trigger is visible)
        const trigger = document.querySelector(".mobile-menu-trigger");
        if (trigger && window.getComputedStyle(trigger).display !== "none") {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(true);
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const showApplyButton =
    !isCreateForm && userType !== "inspect" && dashboard === "console" && !!context.org;
  const showCreateButton = !isCreateForm && userType !== "inspect" && dashboard !== "task" && !!context.org;

  const dropdownContent = (
    <div className="mobile-menu-dropdown">
      <div className="mobile-menu-item mobile-menu-search">
        <GlobalSearch key={pathname} />
      </div>
      <div className="mobile-menu-item mobile-menu-row">
        <span className="mobile-menu-label">Theme</span>
        <CircularThemeSwitch />
      </div>
      <div className="mobile-menu-item mobile-menu-row">
        <span className="mobile-menu-label">Notifications</span>
        <NotificationBellButton />
      </div>
      {showApplyButton ? (
        <div className="mobile-menu-item">
          <Button
            type="text"
            block
            onClick={() => {
              dispatch(applyActions.initialize({ itemLink: "", previousPath: pathname }));
              navigate("/console/apply");
            }}
            icon={<Terminal size={16} />}
          >
            apply
          </Button>
        </div>
      ) : null}
      {showCreateButton ? (
        <div className="mobile-menu-item mobile-menu-create">
          <GenericCreate />
        </div>
      ) : null}
    </div>
  );

  return (
    <Dropdown
      popupRender={() => dropdownContent}
      trigger={["click"]}
      placement="bottomRight"
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Button type="text" className="mobile-menu-trigger" icon={<Menu size={20} />} />
    </Dropdown>
  );
};
